import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tb-fsl-content" }
const _hoisted_2 = { class: "tb-fsl-content-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tb-fsl-content-col" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "tb-fsl-po-heading" }, [
    /*#__PURE__*/_createTextVNode(" Toyota Finance Full‑Service Lease"),
    /*#__PURE__*/_createElementVNode("sup", null, "[F6]")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "tb-fsl-po-result text-body-3 mt-2 mb-0" }, [
    /*#__PURE__*/_createTextVNode(" Your monthly payment includes service and maintenance and Toyota Genuine comprehensive insurance"),
    /*#__PURE__*/_createElementVNode("sup", null, "[F11]"),
    /*#__PURE__*/_createTextVNode(" for your Vehicle. You also have the option to include registration, tyres, and Toyota Roadside Assist"),
    /*#__PURE__*/_createElementVNode("sup", null, "[TF3]"),
    /*#__PURE__*/_createTextVNode(". CTP and vehicle registration included for the first 12 months of the Full-Service Lease"),
    /*#__PURE__*/_createElementVNode("sup", null, "[F6]"),
    /*#__PURE__*/_createTextVNode(" and are optional inclusions for the remaining term of your lease. ")
  ])
], -1)
const _hoisted_4 = { class: "tb-fsl-content-col tb-auto" }
const _hoisted_5 = ["href"]

import { computed } from 'vue';
	import { useStore } from 'vuex';
	import { IStoreState } from '@/types';
	import "vue-select/dist/vue-select.css";
	import { SendCampaignAnalyticsButtonClick, sendCampaignAnalyticsButtonClick } from '@/helpers';

	
export default /*#__PURE__*/_defineComponent({
  name: 'DetailHeaderFSLContent',
  setup(__props) {

	const store = useStore<IStoreState>();

	const vehicleHash = computed(() => store.getters['DetailApp/vehicleHash']);
	const requestAQuoteUrl = computed(() => {
		const url = `/finance/full-service-lease/quote?m=${vehicleHash.value}`;
		return url;
	});

	const handleRequestAQuoteClick = (e: MouseEvent) => {
		const el = e.target as HTMLAnchorElement;
		const ds = {
			buttonName: "Enquire Now",
			enquiryType: "Full Service Lease",
			interactionType: "Full Service Lease",
			marketingOfferId: "",
			vehicleModel: store.state.DetailApp.vehicle.VehicleLine
		}
		const obj: SendCampaignAnalyticsButtonClick = {
			event: "click_button",
			enquiry_type: ds.enquiryType || "",
			button_name: ds.buttonName || "",
			interaction_type: ds.interactionType || "", 
			marketing_offer_id: ds.marketingOfferId || "",
			vehicle_model: ds.vehicleModel || ""
		}
		for (const k in obj) {
			if (!(obj as any)[k]){
				delete (obj as any)[k];
			}
		}
		if (!e.shiftKey && !e.ctrlKey) {
			e.preventDefault();
		}
		sendCampaignAnalyticsButtonClick(obj);
		if (!e.shiftKey && !e.ctrlKey) {
			setTimeout(() => {
				const href = el.getAttribute('href');
				(window as any).location = href;
			}, 100);
			e.preventDefault();
		}
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: _unref(requestAQuoteUrl),
          class: "tb-button-outline",
          onClick: handleRequestAQuoteClick
        }, "Enquire Now", 8, _hoisted_5)
      ])
    ])
  ]))
}
}

})